module.exports = __webpack_public_path__ + "static/offerBot-e8542a2ebb6ee32d0e3ce8a24f34a181.png";